import {
  Link as ConstellationLink,
  Accordion as ConstellationAccordion,
  Button as ConstellationButton,
  TextField as ConstellationTextField,
  Checkbox as ConstellationCheckbox,
  MemorableDate as ConstellationMemorableDate,
} from '@constellation/core';

import withTaggingCheckboxChangeHandler from '../../utils/taggingHandlers/withTaggingCheckboxChangeHandler/withTaggingCheckboxChangeHandler';
import withTaggingFieldAccordionClickHandler from '../../utils/taggingHandlers/withTaggingFieldAccordionClickHandler/withTaggingFieldAccordionClickHandler';
import withTaggingButtonClickHandler from '../../utils/taggingHandlers/withTaggingFieldButtonClickHandler/withTaggingButtonClickHandler';
import withTaggingFieldChangeHandler from '../../utils/taggingHandlers/withTaggingFieldChangeHandler/withTaggingFieldChangeHandler';
import withTaggingFieldLinkClickHandler from '../../utils/taggingHandlers/withTaggingFieldLinkClickHandler/withTaggingFieldLinkClickHandler';
import withTaggingMemorableChangeHandler from '../../utils/taggingHandlers/withTaggingMemorableChangeHandler/withTaggingMemorableChangeHandler';

const Link = withTaggingFieldLinkClickHandler(ConstellationLink);
const Button = withTaggingButtonClickHandler(ConstellationButton);
const Accordion = withTaggingFieldAccordionClickHandler(ConstellationAccordion);
const TextField = withTaggingFieldChangeHandler(ConstellationTextField);
const Checkbox = withTaggingCheckboxChangeHandler(ConstellationCheckbox);
const MemorableDate = withTaggingMemorableChangeHandler(
  ConstellationMemorableDate,
);

export { Link, Accordion, Button, TextField, Checkbox, MemorableDate };
